<template>
    <div>
        <v-container>
            <v-sheet class="pa-5 text-center" elevation="3">
                <v-row>
                    <v-col>
                        <div class="text-center copy">
                            <h3>
                                <!-- TODO: get correct verbiage -->
                                There was a System error.
                                Click <a href="/">HERE</a> to return to the start of the application.
                            </h3>
                        </div>
                    </v-col>
                </v-row>
            </v-sheet>
        </v-container>
    </div>
</template>
<script>
    export default {

    }
</script>
